var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDices = function SvgIconDices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M14.511 12.74c0-.73-.29-1.43-.806-1.945a2.75 2.75 0 0 0-1.944-.806h-7a2.75 2.75 0 0 0-2.75 2.75v7c0 .73.29 1.43.805 1.945a2.75 2.75 0 0 0 1.945.805h7a2.75 2.75 0 0 0 2.75-2.75zm-2.75 6a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-6-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2.5-2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m2.5-2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4 1a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.028 8.99h2.733a3.747 3.747 0 0 1 3.75 3.75v2.591c.824.28 1.391.461 1.427.474a2.75 2.75 0 0 0 3.518-1.656l2.371-6.587a2.747 2.747 0 0 0-1.657-3.518l-6.586-2.37a2.75 2.75 0 0 0-2.102.1c-.66.31-1.17.87-1.417 1.556zm9.18 3.287a1 1 0 1 0-1.884-.677 1 1 0 0 0 1.883.677m-2.109-4.479a1 1 0 1 0-.676 1.882 1 1 0 0 0 .676-1.882m-.903-1.919a1.001 1.001 0 1 0-1.884-.677 1.001 1.001 0 0 0 1.884.677",
    clipRule: "evenodd"
  })));
};
export default SvgIconDices;